import { Injectable } from '@angular/core';
import { SearchPagesAdapter } from './search-pages.adapter';
import { BehaviorSubject, take } from 'rxjs';
import { SearchPagesRequest } from './search-pages.model';
import { initialStatus, loadingStatus } from '../../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class SearchPagesService {
  protected searchRequest$ = new BehaviorSubject<SearchPagesRequest>({ ...initialStatus });

  constructor(private searchPagesAdapter: SearchPagesAdapter) {}

  get() {
    return this.searchRequest$.asObservable();
  }

  set(response: SearchPagesRequest) {
    this.searchRequest$.next(response);
  }

  fetch(query: string, pageNumber: number) {
    this.set(loadingStatus);

    this.searchPagesAdapter
      .fetch(query, pageNumber)
      .pipe(take(1))
      .subscribe(searchRequest => {
        this.set(searchRequest);
      });
  }
}
